interface PaginationLink {
    url: string | null; // URL of the link or null if not applicable
    label: string; // Text for the link label
    active: boolean; // Indicates if this link is currently active
}

interface Pagination {
    current_page: number; // The current page number
    from: number; // The starting record number
    last_page: number; // The last page number
    links: PaginationLink[]; // An array of pagination links
    path: string; // The base path for pagination links
    per_page: number; // Number of records per page
    to: number; // The ending record number on the current page
    total: number; // Total number of records
}

export class ApiResponse<T> {
    data?: T;
    metaData?: Pagination;
    succeeded?: boolean;
    errors?: any;
}